import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';

import { cn, cva, type VariantProps } from '@lib/utils';

const boxVariants = cva(['relative', 'break-words', 'print:border'], {
  variants: {},
  defaultVariants: {},
});

export type BoxProps<T extends ElementType = 'div'> = {
  /** The element type to render as */
  as?: T;
  /** Child elements */
  children?: ReactNode;
} & VariantProps<typeof boxVariants> &
  Omit<ComponentPropsWithoutRef<T>, 'children'>;

function Box<T extends ElementType = 'div'>({ as, className, children, ...rest }: BoxProps<T>) {
  const Component = as ?? 'div';

  return (
    <Component className={cn(boxVariants({}), className)} {...rest}>
      {children}
    </Component>
  );
}

Box.displayName = 'Box';

export { Box, boxVariants };
